import { Component, ElementRef, EventEmitter, Output, Renderer2, RendererStyleFlags2, ViewChild } from '@angular/core';
import { InputTextRenderer } from '../input-text.component';
import { Constants } from 'src/app/shared/utils/constants';
import { Utils } from 'src/app/shared/utils/utils';
import { EndpointDatasetLogicService } from 'src/app/shared/components/endpoint-dataset/endpoint-dataset.logic.service';

@Component({
  selector: 'app-input-text-dataset',
  templateUrl: './input-text-dataset.component.html',
  styleUrls: ['./input-text-dataset.component.css']
})
export class InputTextDatasetRenderer extends InputTextRenderer {
  private messageTimeout: any; 
  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;
  constructor (private renderer: Renderer2, public readonly logicService: EndpointDatasetLogicService)
  {
    super();
  }
  omitIllegalCharacters(event: any) {
    Utils.omitIllegalCharacters(event,Constants.illegalCharacters);
  }

  omitIllegalCharactersOnPaste(event: any) {
    Utils.omitIllegalCharactersOnPaste(event, Constants.illegalCharacters)
  }

  public override onBlur(event: any) {
    let isValid = this.isValid;
    super.onBlur(event)
    this.isValid = isValid;
  }

  async onKeyUp(event: any) {
    const isEEA = this.parent.isEEA;
  
    const updateDescriptions = (array: any, newValue: string, index: number): any[] => {
      return array.map((obj: any, i: number) => {
        if (i === index) {
          return { ...obj, description: newValue };
        }
        return obj;
      });
    };
  
    const updatedArray = updateDescriptions(this.parent.rowData, this.value, this.params.rowIndex);
  
    const invalidRows = updatedArray.some((row: any) =>
      row.description == undefined ||
      row.description == '' ||
      (isEEA ? row.compoundPk == -1 : row.moleculePk == -1) ||
      (isEEA ? row.compoundPk == undefined : row.moleculePk == undefined)
    );
  
    const transactionOcurrences = this.logicService.getTransactionOccurrences(updatedArray);
    const duplicateDatasetsInTransaction = this.logicService.duplicateDataInRecord(transactionOcurrences);
  
    const datasetPk = this.params.data.datasetPk ?? -1;
    let existsDatasetProjectPk: number = -1;
  
    if (
      this.value != undefined &&
      this.value != '' &&
      this.params.data.compoundPk != undefined &&
      this.params.data.substanceType != null
    ) {
      existsDatasetProjectPk = await this.logicService.existsDatasetByName(
        this.value,
        this.params.data.compoundPk,
        datasetPk,
        this.params.data.substanceType
      );
    }
  
    this.isValid =
      !invalidRows &&
      !duplicateDatasetsInTransaction &&
      (existsDatasetProjectPk == -1 || existsDatasetProjectPk == this.logicService.projectPk);
    this.parent.enableControls(this.isValid);
    clearTimeout(this.messageTimeout); 

    this.messageTimeout = setTimeout(() => {
      if (duplicateDatasetsInTransaction && this.logicService.projectPk) {
        this.showExistingDatasetMessage(this.logicService.projectPk);
      } else if (existsDatasetProjectPk > 0 && existsDatasetProjectPk != this.logicService.projectPk) {
        this.showExistingDatasetMessage(existsDatasetProjectPk);
      }
    }, 1750);
  }

  private async showExistingDatasetMessage(
      existsDatasetProjectPk: number
    ): Promise<void> {
      const { name, description, projectPk, createdBy } =
        await this.logicService.getProjectByPk(existsDatasetProjectPk);
        Utils.showErrorMessageHtmlToast(
          'The dataset name already exists for the parent selected',
          `
            <br> <b> Project:</b> ${name} - <b>${projectPk}</b>
            <br> <b> Created by:</b> ${createdBy}
            <br> <b> Description:</b> ${description || 'No description'}
            <br><br>
            <div style="margin-top: 15px; font-size: 20px; font-weight: bold; text-align: center;">
              <u>Please use another name</u>
            </div>
          `
        );
    }
}


